<template>
  <div class="topic_zone_modify" :style="{ 'padding-bottom': rHeight }">
    <div class="tz_header">
      <van-icon name="arrow-left" @click="onClickLeft" class="lh-backicon" />
      <div class="head_info" v-if="data.game_info">
        <span class="hi_name">{{ data.game_info.game_name }}</span>
      </div>
      <Dropdown placement="bottom-end" key="dropdown" @on-click="handleDropdown">
        <van-icon name="ellipsis" />
        <DropdownMenu slot="list">
          <DropdownItem name="report" key="report" v-if="dropdown.includes('report')">
            <Icon type="md-alert" />
            <span>举报</span>
          </DropdownItem>
          <DropdownItem name="shield" key="shield" v-if="dropdown.includes('shield')">
            <!-- <Icon type="md-minus-circled" /> -->
            <Icon type="md-remove-circle"></Icon>
            <span>屏蔽</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <panel class="topic_panel">
        <div :class="{
          focus_btn: true,
          unfocus: !data.user_info.followerFlag,
          focus: data.user_info.followerFlag,
        }" @click="focus" v-if="data.user_info">
          {{ data.user_info.followerFlag ? "已关注" : "+关注" }}
        </div>
        <topic :topic-id="topicId" :user-id="data.user_info.user_id" :row="data" v-if="data.user_info&&data.topic_info">

          <topic-user :avatar="data.user_info.head_img" :nickname="data.user_info.nick_name"
            :publishTime="data.topic_info.publish_time" :label="data.topic_info.tag_list" />
          <topic-title line-feed line-two unsetWhiteSpace :title="data.topic_info.title" />
          <!-- <ali-player :video-id="data.videos.split(',')[0]" style="margin-bottom: 10px" v-if="data.videos" /> -->
          <topic-desc :content="data.topic_info.content" @resetReply="resetReply" />
          <topic-buttons :comment="data.topic_info.comment" :like="data.topic_info.like"
            :is-like="data.topic_info.likeFlag" @resetReply="resetReply" />
          <game-zone v-if="data.game_info" :gameIcon="data.game_info.game_icon" :gameName="data.game_info.game_name"
            :gameId="data.game_info.id" :follows="data.game_info.follows" :topicNum="data.game_info.topic_nums" />
        </topic>
        <Spin
          style="position:fixed;top:2.5rem;left:0;width:100%;height:calc(100% - 2.5rem);z-index:1000;background-color:#f2f2f2;display:flex;justify-content: center;align-items: center;"
          v-else></Spin>
      </panel>

      <div class="replay_area">
        <panel-title :img="'all'" :text="`全部回帖(${totalComment})`">
          <dropdown-sort slot="extra" :sort.sync="sort" :isTopic="true" @refreshComment="refreshComment" />
        </panel-title>

        <component :is="'topic-scroll'" url="topic/get-comments" :params="params" ref="topicscroll" id="game_panel_list"
          :style="{'min-height': minHeight}" @on-fetch="handleFetch">
          <panel slot-scope="scope" class="topic_panel_modify">
            <template v-for="(row, i) in scope.data">
              <div class="comments-items" :class="'comments-items'+i">
                <div class="comment_user" @click="changeReplyUser(row.nick_name, row.id, i)">
                  <img class="user_icon" :src="row.head_img" alt="">
                  <div class="comment_line1">
                    <div class="name_floor">
                      <span class="user_name">{{ row.nick_name }}</span>
                      <span class="floor">#{{ row.floor }}</span>
                    </div>
                    <div class="create_time">
                      {{ row.create_time.slice(0,16) }}
                    </div>
                  </div>
                  <Icon class="shield_icon" type="md-remove-circle" @click.stop="doShield(i+1)" />
                
                  <img class="jb_warning" src="../../assets/icons/report.png" alt="" @click.stop="doReport(row.nick_name, row.id)">
                </div>
                <div class="comment_content" @click="changeReplyUser(row.nick_name, row.id, i)">{{ row.content }}</div>
                <div class="comment_imgs" v-if="row.imgs">
                  <img :src="item2" alt="" v-for="(item2, k) in row.imgs" :key="k" @click="imgPreview(row.imgs, k)">
                </div>

                <div class="floor_reply" v-if="row.childrenComment && row.childrenComment.length > 0"
                  @click="gotoTopicComment(row.nick_name, row.id, i)">
                  <div class="fr_item" v-for="(fitem, k) in row.childrenComment.slice(0, 2)" :key="k">
                    {{ fitem.user_name }}
                    <span class="black">：{{ fitem.content }}
                    </span>
                  </div>
                  <div class="all_replynum" v-if="row.children > 2" @click="openPop(row.id,i)">
                    全部回复{{ row.children }}条<span class="sanjiao"></span>
                  </div>
                </div>
                <div class="date_like_comment">
                  <div></div>
                  <div class="like_comment">
                    <img class="icon_item comment_btn" src="../../assets/icons/comment.png" alt="">
                    <img class="icon_item" src="../../assets/icons/like.png" alt="" v-if="!row.like_flag"
                      @click="operateComment(1,row.id,i)">
                    <img class="icon_item" src="../../assets/icons/like_o.png" alt="" v-else
                      @click="operateComment(2,row.id,i)">
                    <img class="icon_item" src="../../assets/icons/unlike.png" alt="" v-if="!row.dislike_flag"
                      @click="operateComment(3,row.id,i)">
                    <img class="icon_item" src="../../assets/icons/unlike_o.png" alt="" v-else
                      @click="operateComment(4,row.id,i)">
                  </div>
                </div>
              </div>
            </template>
          </panel>
        </component>
      </div>
    </van-pull-refresh>
    <div class="tz_reply" ref="tzReply" v-if="data.topic_info">
      <div class="reply_user" v-if="postName">@ <span>{{ postName }}</span></div>
      <div class="tr_area">
        <i-input class="reply_ipt" type="textarea" :disabled="!data.topic_info.can_reply" autosize
          :placeholder="data.topic_info.can_reply ? '善语结善人，恶语显示人品' :'该贴暂不支持回复'" v-model="replymsg" @on-focus="focusSmg"
          @on-change="changeVal" :maxlength="500" ref="smgipt"></i-input>
        <Button class="smg_btn" :disabled="(replymsg == '' && data.topic_info.can_reply)" @click="sendmesg"
          :loading="submitloading > 0">发送</Button>
      </div>
    </div>

    <Back-top :height="300">
      <img src="../../assets/icons/return_top.png" alt="">
    </Back-top>

    <van-popup class="comment_popup" v-model="showPop" :style="{ height: '90%' }" get-container="#app"
      position="bottom">
      <div class="pop_header">
        <van-icon name="cross" @click="closePop" />
      </div>
      <div class="pop_body">
        <div class="pc_content">
          <div class="comment_user">
            <img class="user_icon" :src="commentData.head_img" alt="">
            <div class="comment_line1">
              <div class="name_floor">
                <span class="user_name">{{ commentData.user_name }}</span>

              </div>
              <div class="create_time" v-if="commentData.create_time">
                {{ commentData.create_time.slice(0,16) }}
              </div>
            </div>
            <Icon class="shield_icon" type="md-remove-circle" @click.stop="doShield()" />
            <img class="jb_warning" src="../../assets/icons/report.png" alt="">
          </div>
          <div class="comment_content">
            {{ commentData.content }}
          </div>
          <div class="date_like_comment">
            <div></div>
            <div class="like_comment">
              <img class="icon_item comment_btn" src="../../assets/icons/comment.png" alt="">
              <img class="icon_item" src="../../assets/icons/like.png" alt="" v-if="!commentData.like_flag"
                @click="operateComment2(1,commentData.id)">
              <img class="icon_item" src="../../assets/icons/like_o.png" alt="" v-else
                @click="operateComment2(2,commentData.id)">
              <img class="icon_item" src="../../assets/icons/unlike.png" alt="" v-if="!commentData.dislike_flag"
                @click="operateComment2(3,commentData.id)">
              <img class="icon_item" src="../../assets/icons/unlike_o.png" alt="" v-else
                @click="operateComment2(4,commentData.id)">
            </div>
          </div>
        </div>
        <div class="replay_area" v-if="showPop">
          <panel-title :img="'all'" :text="`${totalComment2}条评论`">
            <dropdown-sort slot="extra" :sort.sync="sort2" :isComment="true" @refreshPopComment="refreshPopComment" />
          </panel-title>

          <component :is="'topic-scroll'" url="topic/get-comments" :params="params2" ref="commentscroll"
            @on-fetch="handleFetch2">
            <panel slot-scope="scope" class="topic_panel_modify">
              <template v-for="(row, i) in scope.data">
                <div class="comments-items">
                  <div class="comment_user" @click="changeReplyUser(row.nick_name, row.id, i)">
                    <img class="user_icon" :src="row.head_img" alt="">
                    <div class="comment_line1">
                      <div class="name_floor">
                        <span class="user_name">{{ row.nick_name }}</span>
                        <!-- <span class="floor">#{{ row.floor }}</span> -->
                      </div>
                      <div class="create_time">
                        {{ row.create_time.slice(0,16) }}
                      </div>
                    </div>
                    <Icon class="shield_icon" type="md-remove-circle" @click.stop="doShield()" />
                  
                    <img class="jb_warning" src="../../assets/icons/report.png" alt="">
                  </div>
                  <div class="comment_content" @click="changeReplyUser(row.nick_name, row.id, i)">{{ row.content }}
                  </div>
                  <div class="comment_imgs" v-if="row.imgs">
                    <img :src="item2" alt="" v-for="(item2, k) in row.imgs" :key="k" @click="imgPreview(row.imgs, k)">
                  </div>

                  <div class="date_like_comment">
                    <div></div>
                    <div class="like_comment">
                      <!-- <img class="icon_item comment_btn" src="../../assets/icons/comment.png" alt=""> -->
                      <img class="icon_item" src="../../assets/icons/like.png" alt="" v-if="!row.like_flag"
                        @click="operateComment3(1,row.id,i)">
                      <img class="icon_item" src="../../assets/icons/like_o.png" alt="" v-else
                        @click="operateComment3(2,row.id,i)">
                      <img class="icon_item" src="../../assets/icons/unlike.png" alt="" v-if="!row.dislike_flag"
                        @click="operateComment3(3,row.id,i)">
                      <img class="icon_item" src="../../assets/icons/unlike_o.png" alt="" v-else
                        @click="operateComment3(4,row.id,i)">
                    </div>
                  </div>
                </div>
              </template>
            </panel>
          </component>
        </div>
      </div>
      <div class="pop_footer">
        <div class="tr_area" v-if="data.topic_info">
          <i-input class="reply_ipt" :disabled="!data.topic_info.can_reply" autosize
            :placeholder="data.topic_info.can_reply ? '善语结善人，恶语显示人品' :'该贴暂不支持回复'" v-model="replymsg2"
            @on-change="changeVal" :maxlength="500" ref="smgipt2"></i-input>
          <Button class="smg_btn" :disabled="(replymsg2 == '' && data.topic_info.can_reply)" @click="sendmesg2"
            :loading="submitloading > 0">发送</Button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    debounce
  } from 'riku-verycloud'
  import {
    ImagePreview,
  } from "vant";
  import api from '../Api'
  import $ from 'jquery'
  export default {
    mixins: [api],
    data() {
      return {
        topicId: this.$route.params.topicId,
        showHeader: false,
        data: {},
        sort: "create_time",
        sort2: "create_time",
        loading: 0,
        dropdown: ['report', 'shield'],
        replymsg: '',
        submitloading: 0,
        rHeight: '5rem',
        replyParams: {},
        minHeight: '4rem',
        postId: null,
        postName: '',
        id: null,
        index: 0,
        totalComment: 0,
        totalComment2: 0,
        // 弹框
        showPop: false,
        comment_id: '',
        commentData: {},
        replymsg2: '',
        submitloading2: 0,
        popIndex: 0
      };
    },
    computed: {
      isLogin() {
        return this.$store.getters.isLogin
      },
      userData() {
        return this.$store.getters.state.userData || {};
      },
      params: {
        get() {
          return {
            topic_id: this.topicId,
            sort: this.sort
          }
        },
        set(newVal) {
          this.params = newVal
        }
      },
      params2: {
        get() {
          return {
            topic_id: this.topicId,
            sort: this.sort2,
            parent: null
          }
        },
        set(newVal) {
          this.params2 = newVal
        }
      },
    },
    mounted() {
      this.$store.dispatch('getUserData', true)
    },
    activated() {

    },
    methods: {
      handleFetch(data) {
        this.totalComment = data.total
      },
      handleFetch2(data) {
        this.totalComment2 = data.total
      },
      refreshComment() {
        this.minHeight = this.$refs.topicscroll.$el.offsetHeight + 'px'
        this.$refs.topicscroll.refresh()
      },
      goToUserCenter(userId) {

      },
      getTopicDtail: debounce(function () {
        this.$Ajax("topic/topic-detail", {
          topic_id: this.topicId
        }).then(rs => {
          if (rs.code == 200) {
            this.data = rs.data;
          }
        })
      }),
      //右上角举报分享按钮
      handleDropdown(name) {
        switch (name) {
          case "report":
            this.doReport(this.data.nick_name,this.data.user_info.user_id);
            break;
          case "shield":
            this.doShield();
            break;
        }
      },
      //举报
      doReport(name, replyId) {
        this.$RModal.report({
          afterTitle: name,
          selection: {
            topicId: this.topicId,
            replyId
          }
        });
      },
      doShield(i) {
        this.$RModal.shield({
          onSuccess: () => {
            if(i) {
              $('.comments-items'+ (i-1)).css('display','none')
            }
          }
        })
      },
      // 分享
      doShare() {
        this.$RModal.share({
          selection: {
            topicId: this.topicId,
            title: this.data.title,
            desc: this.data.desc,
            attachments: this.data.attachments
          }
        });
      },
      focusSmg() {
        // if (!this.isLogin) {
        //   this.$refs.smgipt.blur()
        //   this.$mypopup({
        //     onSuccess: () => {
        //       this.$refs.smgipt.focus()
        //     }
        //   })
        // }
      },
      //发送回帖
      sendmesg() {
        this.submitloading++
        this.replyParams.topic_id = this.topicId
        this.replyParams.content = this.replymsg
        if (this.postId) {
          this.replyParams.postId = this.postId
        }
        if (this.id) {
          this.replyParams.id = this.id
        }
        // if (this.imgList.length > 0) {
        //   this.replyParams.imgs = JSON.stringify(this.imgList)
        // }
        this.$Ajax('topic/create-comment', this.replyParams).then(rs => {
          if (rs.code == 200) {
            this.data.topic_info.comment++
            if (!this.id) {
              this.$refs.topicscroll.data.unshift({
                head_img: this.userData.head_img,
                user_name: this.userData.nick_name,
                content: this.replymsg,
                create_time: rs.data.date,
                id: rs.data.id,
                floor: rs.data.floor,
                like_flag: false,
                dislike_flag: false,
                // vote_num: 0,
                // voteFlag: 0,
                childrenComment: [],
                //imgs: this.imgList
              })
            } else {
              this.$refs.topicscroll.data[this.index].childrenComment.unshift({
                user_name: this.userData.nick_name,
                content: this.replymsg,
              })
              this.$refs.topicscroll.data[this.index].children++
            }
            this.replymsg = ''
            // this.fileList = []
            // this.imgList = []
            this.$toast(rs.msg)
          }
        }).finally(() => {
          var that = this
          setTimeout(() => {
            that.submitloading--
          }, 2000)
        })
      },
      //点击切换评论对象
      changeReplyUser(name, id, i) {
        // this.showUploadImg = false
        // this.fileList = []
        // this.imgList = []
        this.postName = name
        this.id = id
        this.index = i
        this.$refs.smgipt.focus()
      },
      //重置回复对象为该帖子
      resetReply() {
        // this.showUploadImg = true
        // this.fileList = []
        // this.imgList = []
        this.postName = ''
        this.id = null
        this.postId = null
        this.$refs.smgipt.focus()
      },
      //输入框数据改变时触发  随时获取高度变化
      changeVal() {
        this.rHeight = this.$refs.tzReply.offsetHeight + 50 + 'px'
      },
      //打开评论详情
      gotoTopicComment(name, id, i) {
        this.postName = name
        this.id = id
        this.index = i
        this.$refs.smgipt.focus()
      },
      //关注用户
      focus() {
        var api = this.data.user_info.followerFlag ? "com/un-follower-user" : "com/follower-user";
        this.$Ajax(api, {
          user_id: this.data.user_info.user_id,
        }).then((rs) => {
          if (rs.code == 200) {
            this.data.user_info.followerFlag = !this.data.user_info.followerFlag
          }
        });
      },
      imgPreview(list, index) {
        ImagePreview({
          images: list,
          startPosition: index,
          closeable: true,
          loop: false
        })
      },
      operateComment(action, comment_id, index) {
        this.$Ajax('/com/operate-comment', {
          action,
          comment_id
        }).then(rs => {
          if (rs.code == 200) {
            if (action == 1) {
              this.$refs.topicscroll.data[index].like_flag = true
              if (this.$refs.topicscroll.data[index].dislike_flag) {
                this.$refs.topicscroll.data[index].dislike_flag = false
              }
            } else if (action == 2) {
              this.$refs.topicscroll.data[index].like_flag = false
            } else if (action == 3) {
              this.$refs.topicscroll.data[index].dislike_flag = true
              if (this.$refs.topicscroll.data[index].like_flag) {
                this.$refs.topicscroll.data[index].like_flag = false
              }
            } else if (action == 4) {
              this.$refs.topicscroll.data[index].dislike_flag = false
            }
          }
        })
      },
      operateComment2(action, comment_id) {
        this.$Ajax('/com/operate-comment', {
          action,
          comment_id
        }).then(rs => {
          if (rs.code == 200) {
            if (action == 1) {
              this.commentData.like_flag =
                this.$refs.topicscroll.data[this.popIndex].like_flag = true
              if (this.commentData.dislike_flag) {
                this.commentData.dislike_flag =
                  this.$refs.topicscroll.data[this.popIndex].dislike_flag = false
              }
            } else if (action == 2) {
              this.commentData.like_flag =
                this.$refs.topicscroll.data[this.popIndex].like_flag = false
            } else if (action == 3) {
              this.commentData.dislike_flag =
                this.$refs.topicscroll.data[this.popIndex].dislike_flag = true
              if (this.commentData.like_flag) {
                this.commentData.like_flag =
                  this.$refs.topicscroll.data[this.popIndex].like_flag = false
              }
            } else if (action == 4) {
              this.commentData.dislike_flag =
                this.$refs.topicscroll.data[this.popIndex].dislike_flag = false
            }
          }
        })
      },
      operateComment3(action, comment_id, index) {
        this.$Ajax('/com/operate-comment', {
          action,
          comment_id
        }).then(rs => {
          if (rs.code == 200) {
            if (action == 1) {
              this.$refs.commentscroll.data[index].like_flag = true
              if (this.$refs.commentscroll.data[index].dislike_flag) {
                this.$refs.commentscroll.data[index].dislike_flag = false
              }
            } else if (action == 2) {
              this.$refs.commentscroll.data[index].like_flag = false
            } else if (action == 3) {
              this.$refs.commentscroll.data[index].dislike_flag = true
              if (this.$refs.commentscroll.data[index].dislike_flag) {
                this.$refs.commentscroll.data[index].dislike_flag = false
              }
            } else if (action == 4) {
              this.$refs.commentscroll.data[index].dislike_flag = false
            }
          }
        })
      },
      //打开评论弹框
      openPop(id, index) {
        this.popIndex = index
        this.showPop = true
        this.comment_id = this.params2.parent = id
        this.$Ajax('topic/get-comment-detail', {
          comment_id: this.comment_id
        }).then(rs => {
          if (rs.code == 200) {
            this.commentData = rs.data
          }
        })
      },
      //关闭评论弹框
      closePop() {
        this.showPop = false
      },

      //按时间、热度切换子评论的评论
      refreshPopComment() {
        this.params2.parent = this.comment_id
        this.$refs.commentscroll.refresh()
      },

      //发送回帖
      sendmesg2() {
        this.submitloading2++
        this.replyParams.topic_id = this.topicId
        this.replyParams.content = this.replymsg2
        if (this.comment_id) {
          this.replyParams.id = this.comment_id
        }
        this.$Ajax('topic/create-comment', this.replyParams).then(rs => {
          if (rs.code == 200) {
            this.totalComment2++
            this.$refs.commentscroll.data.unshift({
              head_img: this.userData.head_img,
              nick_name: this.userData.nick_name,
              content: this.replymsg2,
              create_time: rs.data.date,
              id: rs.data.id,
            })
            this.replymsg2 = ''
            this.$toast(rs.msg)
          }
        }).finally(() => {
          var that = this
          setTimeout(() => {
            that.submitloading2--
          }, 2000)
        })
      },
    },
    watch: {
      '$route.params.topicId': {
        immediate: true,
        handler(t) {
          this.topicId = t
          this.getTopicDtail()
        }
      },
    }
  };
</script>

<style lang="less" scoped>
  #game_panel_list {
    .r-panel {
      background-color: transparent;
      padding: 0;
    }
  }

  .topic_zone_modify {
    padding-top: 2.5rem;

    .tz_header {
      position: fixed;
      top: 0;
      width: 100%;
      height: 2.5rem;
      padding: 0 .8rem;
      background-color: #fff;
      border-bottom: 1px solid #eee;
      z-index: 101;

      .lh-backicon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: .8rem;
        color: #1d2127;
        font-size: 1.1rem;
        cursor: pointer;
      }

      .head_info {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;

        .hi_icon {
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          margin-right: .3rem;
        }

        .hi_name {
          font-weight: 700;
          font-size: .8rem;
          color: #000;
          flex: 1;
        }
      }

      /deep/.ivu-dropdown {
        position: absolute;
        top: 50%;
        right: .8rem;
        transform: translateY(-50%);

        .ivu-dropdown-rel {
          height: 1.1rem;
        }

        .van-icon.van-icon-ellipsis {
          font-weight: 700;
          font-size: 1.2rem;
          cursor: pointer;
          color: #000;

          &:hover {
            color: #670000;
          }
        }
      }
    }

    /deep/.r-topic {

      .r-topic-buttons {
        display: flex;
        justify-content: flex-end;
        margin: .55rem 0 1.25rem;

        .icons {
          display: flex;
          align-items: center;
        }
      }
    }

    .r-panel-title {
      background-color: #fff;
      position: sticky;
      top: 2.45rem;
      z-index: 10;
    }

    .tz_reply {
      position: fixed;
      bottom: 0;
      width: 100%;
      min-height: 3.4rem;
      width: 100%;
      background-color: #fff;
      box-shadow: 0 .15rem .3rem .05rem rgba(0, 0, 0, 0.16);
      padding: 0.6rem 0.75rem;
      z-index: 501;

      .reply_user {
        font-size: 0.6rem;
        margin-bottom: 0.2rem;

        span {
          display: inline-block;
          transform: translateY(0.05rem);
        }
      }

      .tr_area {
        display: flex;
        align-items: flex-end;
      }

      /deep/.reply_ipt {
        flex: 1;
        min-height: 1.6rem;

        .ivu-input {
          line-height: unset;
          border-radius: 1rem;
        }

        textarea {
          resize: none;
          min-height: 1.6rem;
          max-height: 4.2rem !important;
          overflow-y: auto !important;
          padding: 0.3rem 0.5rem;
          font-size: 0.65rem;

        }
      }

      .smg_btn {
        width: 3.9rem;
        height: 1.6rem;
        border-radius: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.6rem;
        margin-left: 0.5rem;
        background-color: #670000;
        color: #fff;
        border: none;

        &:disabled {
          background-color: #c5c5c7;
          color: #fff;
        }
      }
    }

    .comments-items {
      background-color: transparent;
      padding: 0.5rem;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        right: .7rem;
        width: calc(100% - 3.4rem);
        height: 1px;
        background-color: #eee;
      }

      &:nth-last-child(1) {
        &::after {
          background-color: transparent;
        }
      }

      .floor_reply {
        margin-left: 2.1rem;
        margin-top: 0.3rem;
        padding: 0.5rem;
        background-color: #f7f7f7;
        border-radius: 0.3rem;
        font-size: 0.65rem;
        cursor: pointer;

        .fr_item {
          word-break: break-all;
          margin-bottom: 0.2rem;
          color: #9e9e9e;
          font-size: .6rem;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .black {
            color: #000;
          }
        }

        .all_replynum {
          color: #670000;
          font-size: 0.6rem;
          display: flex;
          align-items: center;

          .sanjiao {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: .25rem .2rem 0 .2rem;
            border-color: #670000 transparent transparent transparent;
            margin-left: 0.2rem;
          }
        }
      }
    }
  }

  .comment_user {
    margin-bottom: .55rem;
    display: flex;
    align-items: flex-start;
    position: relative;
    cursor: pointer;

    .user_icon {
      width: 1.7rem;
      height: 1.7rem;
      border-radius: 50%;
      margin-right: 0.4rem;
    }

    .comment_line1 {
      display: flex;
      flex-direction: column;
      align-items: space-between;

      .create_time {
        font-size: .6rem;
        color: #878787;
      }
    }

    .user_name {
      color: #000;
      font-size: 0.6rem;
      font-weight: 700;
    }

    .floor {
      font-size: 0.6rem;
      margin-left: 0.3rem;
      color: #670000;
    }
    .shield_icon {
      position: absolute;
      right: 1.8rem;
      top: 50%;
      transform: translateY(-50%);
    }
    .jb_warning {
      position: absolute;
      right: 0.25rem;
      top: 50%;
      transform: translateY(-50%);
      width: .6rem;
      height: .7rem;
      cursor: pointer;
    }
  }

  .comment_content {
    cursor: pointer;
    padding-left: 2.1rem;
    padding-right: 0.5rem;
    font-size: 0.6rem;
    color: #474747;
    word-break: break-word;
  }

  .comment_imgs {
    margin-top: 0.3rem;
    display: flex;
    align-items: center;

    img {
      display: inline-block;
      width: 18%;
      height: auto;
      margin-left: 2%;
    }
  }

  /deep/.extra {
    .ivu-dropdown {
      .ivu-btn {
        height: 1.2rem;
      }
    }
  }

  /deep/.topic_panel {
    position: relative;

    .focus_btn {
      width: 2.75rem;
      height: 1.4rem;
      line-height: 1.4rem;
      text-align: center;
      position: absolute;
      right: 0.75rem;
      top: 1rem;
      z-index: 1;
      font-size: 0.6rem;
      border-radius: .2rem;
      cursor: pointer;
      border-radius: 5rem;

      &.unfocus {
        background-color: #ecd7d5;
        color: #670000;
      }

      &.focus {
        background-color: #ecd7d5;
        color: #670000;
      }
    }
  }

  .upload_plus {
    position: relative;
    width: 1.2rem;
    height: 1.2rem;
    border: 1px solid #bbb;
    border-radius: 50%;
    margin: 0 0 0.15rem 0.5rem;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 0.6rem;
      height: 1px;
      border-radius: 2px;
      background-color: #bbb;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }

  .replay_area {
    margin: 0 .75rem;
    background-color: #E4E4E4;
    border-radius: .7rem;

    .r-panel-title {
      background-color: #e4e4e4;
      border-top-left-radius: .7rem;
      border-top-right-radius: .7rem;
    }
  }

  .comment_popup {
    display: flex;
    flex-direction: column;
    background-color: #E4E4E4;

    .pop_header {
      width: 100%;
      height: 2.2rem;
      position: relative;

      .van-icon {
        position: absolute;
        right: 0.8rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1rem;
        color: #000;
      }
    }

    .pop_body {
      flex: 1;
      overflow-y: auto;
      padding: 0 .75rem 1rem;

      .pc_content {
        padding: .6rem .5rem;
        background-color: #fff;
        border-radius: .7rem;
        margin-bottom: .6rem;
      }

      .replay_area {
        margin: 0;
        background-color: #fff;

        .r-panel-title {
          background-color: #fff;
          z-index: 10;
          position: sticky;
          top: 0;
        }

        .r-panel {
          background-color: #fff;

          .comments-items {
            padding: 0.5rem 0;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              bottom: 0;
              right: 0;
              width: calc(100% - 2.1rem);
              height: 1px;
              background-color: #e6e6e6;
            }

            &:nth-last-child(1) {
              &::after {
                background-color: transparent;
              }
            }
          }
        }
      }
    }

    .pop_footer {
      width: 100%;
      min-height: 3.4rem;
      background: #fff;
      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
      padding: 0.6rem 0.75rem;

      .tr_area {
        display: flex;
        align-items: flex-end;
      }

      /deep/.reply_ipt {
        flex: 1;
        min-height: 1.6rem;

        .ivu-input {
          line-height: unset;
          border-radius: 1rem;
        }

        input.ivu-input {
          padding: 0.3rem 0.5rem;
        }

        textarea {
          resize: none;
          min-height: 1.6rem;
          max-height: 4.2rem !important;
          overflow-y: auto !important;
          padding: 0.3rem 0.5rem;
          font-size: 0.65rem;

        }
      }

      .smg_btn {
        width: 3.9rem;
        height: 1.6rem;
        border-radius: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.6rem;
        margin-left: 0.5rem;
        background-color: #670000;
        color: #fff;
        border: none;

        &:disabled {
          background-color: #c5c5c7;
          color: #fff;
        }
      }
    }
  }

  .date_like_comment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: .7rem;
    margin-bottom: .3rem;

    .c_calendar {
      padding: 0;
      color: #c5c8ce;

      &:hover,
      &:focus {
        box-shadow: none;
        color: #c5c8ce;
      }
    }

    .like_comment {
      display: flex;
      align-items: center;

      .icon_item {
        width: .55rem;
        height: .55rem;
        margin-left: .6rem;

        &.comment_btn {
          width: .65rem;
        }
      }
    }
  }
</style>